import styles from "./styles/mastering-player.module.scss";
import PlayerButton from "@/components/common/player-button";
import PlayerProgress from "@/components/common/music-player/player-progress";
import React from "react";
import { useAudioPlayerContext } from "@/hooks/audio/use-audio-player-context";
import Image from "next/image";
import useAudioPlayer from "@/hooks/music-players/use-audio-player";

type Props = {
  trackUrl: string;
  titles: string[];
  onAction: () => void;
  actionIcon: any;
};

const MasteringPlayer = ({ trackUrl, titles, onAction, actionIcon }: Props) => {
  const { handlePlayButtonClick, isPlayerActive } = useAudioPlayerContext();
  const {
    musicPlayer,
    progressRef,
    changeRange,
    onDurationChanged,
    onTimeUpdate,
  } = useAudioPlayer();

  return (
    <>
      <audio
        ref={musicPlayer}
        onDurationChange={onDurationChanged}
        onTimeUpdate={onTimeUpdate}
        src={trackUrl}
      />
      <div className={styles.wrapper}>
        <h3>
          {titles.map((title, index) => (
            <div key={index}>
              {title}
              {index < titles.length - 1 && <span> • </span>}
            </div>
          ))}
        </h3>
        <div className={styles.player}>
          <PlayerButton
            handleClick={() => handlePlayButtonClick(musicPlayer)}
            isPlaying={isPlayerActive(musicPlayer)}
            size={24}
          />
          <PlayerProgress
            musicPlayer={musicPlayer}
            progressRef={progressRef}
            onChange={changeRange}
          />
          <div className={styles.action} onClick={onAction}>
            <Image src={actionIcon} alt={"delete"} height={24} width={24} />
          </div>
        </div>
      </div>
    </>
  );
};

export default MasteringPlayer;
